'use client';

import ConfigContext from './ConfigContext';
import {SafeConfigValue } from '@chewy/central-config-cron';
import { useMemo } from 'react';
interface PageProps {
  children: React.ReactNode;
  configs: Map<string, SafeConfigValue> | null
}
/**
 * Client Component that fetches all Athena config on mount
 * Provides config through Context to all child components
 */
const ConfigProvider = ({ children, configs}: PageProps) => {
  const configValues = useMemo(
    () => (configs ? Object.fromEntries(configs): {}),
  [configs]
  )
  console.log("ConfigProviders:",configs)
  return <ConfigContext.Provider value={configValues}>{children}</ConfigContext.Provider>;
};

export default ConfigProvider;
